import * as React from 'react';
import { SVGProps } from 'react';

const SvgLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M8.9 23.4h6v6.2h-6v-6.2z" />
    <path fill={props.fill} d="M31.8 29.4H4.3v4h32.1l-4.6-4z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M19 19.4H4.7m11.2 4.2h-8"
    />
    <path
      fill="currentColor"
      d="M7.9 12.8c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm5 1h1.7v-2h-1.7v-1.7h-2v1.7H9.2v2h1.7v1.7h2v-1.7zm8.6 1.6h3v3h-3v-3zm3.9 0h3v3h-3v-3zm-3.9 4h3v3h-3v-3zm3.9 0h3v3h-3v-3zm-3.9 4h3v3h-3v-3zm3.9 0h3v3h-3v-3z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M3 6.5h17.9M5 29.4V6.5h14v22.9m12 0V12.7H19"
    />
  </svg>
);

export default SvgLocation;
